export enum QueryKeys {
  STANDARDIZED_NETWORKS = "standardizedNetworks",
  SUPPORTED_EXCHANGES = "supportedExchanges",
  WITHDRAWABLE_CURRENCIES = "withdrawableCurrencies",
  VAULT_TRANSACTIONS = "getVaultTransactions",
  VAULTS_QUERY_KEY = "vaults",
  VAULTS_EVENTS_QUERY_KEY = "vaults-events",
  PROVIDER_EVENTS_QUERY = "provider-events",
  AVAILABLE_EXCHANGES = "availableExchanges",
  PARTNERS = "partners",
  CONFIG = "config",
  ADDRESS_BOOK = "addressBook",
  USER_REWARDS = "userRewards",
  QUESTS = "quests",
  PASSWORDLESS_LOGIN = "passwordlessLogin",
  ENVIRONMENT = "environment",
  PENDING_APPROVAL_REQUEST = "pendingApprovalRequest",
  DISCORD_STATUS = "DISCORD_STATUS",
  REFERRAL_CODE = "referralCode",
  HAS_JOINED_DISCORD = "hasJoinedDiscord",
  USER_MULTIPLIERS = "userMultipliers",
  MULTIPLE_TX_FEES = "multipleTxFees",
  LEADERBOARD = "leaderboard",
  BYPASS_APPROVAL_TRADE_HUB = "bypassApprovalTradeHub",
  CAMPAIGN_OPEN_ORDERS = "campaignOpenOrders",
  CEDE_STORE_VERSION = "cedeStoreVersion",
  CAMPAIGNS_METADATA = "campaignsMetadata",
  GENERAL_STATS = "generalStats",
  USER_STATS = "userStats",
  GLOBAL_LEADERBOARD = "globalLeaderboard",
  LAST_COMPUTED_EVENT = "lastComputedEvent",
  PHASE_VOLUME = "phaseVolume",
  HUB_OAUTH_INIT = "hubOauthInit",
  PRICES = "prices",
  POPULAR_TOKENS = "popularTokens",
  ON_BOARDING_STEPS = "onBoardingSteps",
  TRADE_TUTORIAL_STEPS = "tradeTutorialSteps",
  HUB_UPDATES = "hubUpdates",
  HUB_BANNERS = "hubBanners",
  CAMPAIGNS_STATS = "campaignsStats",
  HUB_REWARDS_CLAIMABLE = "hubRewardsClaimable",
  HUB_REWARDS_CLAIMABLE_SPINNING_WHEEL = "hubRewardsClaimableSpinningWheel",
  HUB_REWARDS_CLAIMABLE_SOON = "hubRewardsClaimableSoon",
  HUB_REWARDS_CLAIMABLE_SOON_SPINNING_WHEEL = "hubRewardsClaimableSoonSpinningWheel",
  HUB_REFERRAL_REWARDS_CLAIMABLE = "hubReferralRewardsClaimable",
  CEDE_ARENA_FINALIZATION = "cedeArenaFinalization",
  QUEST_LIVE = "questLive",
  QUEST_TMA_ONBOARDING_LIVE = "questTmaOnboardingLive",
  QUEST_TMA_USER_COMPLETIONS = "questTmaUserCompletions",
  QUEST_USER_PROGRESS = "questUserProgress",
  QUEST_USER_COMPLETIONS = "questUserCompletions",
  QUEST_USER_ELIGIBILITY = "questUserEligibility",
  QUEST_X_CAMPAIGN_INTERACTION = "questXCampaignInteraction",
  QUEST_X_CAMPAIGN_INTERACTION_ELIGIBILITY = "questXCampaignInteractionEligibility",
  QUEST_X_CAMPAIGN_INTERACTION_COMPLETIONS = "questXCampaignInteractionCompletions",
  QUEST_X_CAMPAIGN_INTERACTION_POST_DATA = "questXCampaignInteractionPostData",
  QUEST_X_CAMPAIGN_INTERACTION_COMMENT_AND_FOLLOW = "questXCampaignInteractionCommentAndFollow",
  QUEST_X_CAMPAIGN_INTERACTION_POST_AND_FOLLOW = "questXCampaignInteractionPostAndFollow",
  LOTTERY_TICKETS = "lotteryTickets",
  LOTTERY_CURRENT_DRAW = "lotteryCurrentDraw",
  LOTTERY_HISTORY = "lotteryHistory",
  LOTTERY_CONFIG = "lotteryConfig",
  HOLD_TO_EARN_CAMPAIGNS = "holdToEarnCampaigns",
  HOLD_TO_EARN_CAMPAIGN = "holdToEarnCampaign",
  HOLD_TO_EARN_PARTICIPANT_STATUS = "holdToEarnParticipantStatus",
  HOLD_TO_EARN_LEADERBOARD = "holdToEarnLeaderboard",
  HOLD_TO_EARN_EPOCH_STATISTICS = "holdToEarnEpochStatistics",
  SPINNING_WHEEL_SLOTS = "spinningWheelSlots",
  SPINNING_WHEEL_SPIN = "spinningWheelSpin",
  SPINNING_WHEEL_COMPLETE_QUEST = "spinningWheelCompleteQuest",
  SPINNING_WHEEL_ELIGIBILITY = "spinningWheelEligibility",
  SPINNING_WHEEL_REWARDS = "spinningWheelRewards",
  SPINNING_WHEEL_TICKETS = "spinningWheelTickets",
  SPINNING_WHEEL_RESULTS = "spinningWheelResults",
  SPINNING_WHEEL_THRESHOLD_PROGRESS = "spinningWheelThresholdProgress",
  SPINNING_WHEEL_RECENT_WINNERS = "spinningWheelRecentWinners",
  ACCOUNT_BALANCES = "accountBalances",

  // Hyperliquid endpoints
  HYPERLIQUID_AGENT_DATA = "hyperliquidAgentData",
  HYPERLIQUID_MARKETS = "hyperliquidMarkets",
  HYPERLIQUID_ELIGIBILITY = "hyperliquidEligibility",

  // Hotstuff endpoints
  HOTSTUFF_AGENT_DATA = "hotstuffAgentData",

  // Hall of Fame endpoints
  HALL_OF_FAME_SEASONS = "hallOfFameSeasons",
  HALL_OF_FAME_USER_RANK_DATA = "hallOfFameUserRankData",
  HALL_OF_FAME_TOP_50 = "hallOfFameTop50",
  HALL_OF_FAME_COUNTDOWN_REWARDS = "hallOfFameCountdownRewards",

  // Cashback endpoints
  CASHBACK_STATUS = "cashbackStatus",
  CASHBACK_CONFIG = "cashbackConfig",
  HUB_REWARDS_CLAIMABLE_CASHBACK = "hubRewardsClaimableCashback",
  HUB_REWARDS_CLAIMABLE_SOON_CASHBACK = "hubRewardsClaimableSoonCashback",

  // Automatic Streak endpoints
  AUTOMATIC_STREAK = "automaticStreak",
  AUTOMATIC_STREAKS = "automaticStreaks",
  AUTOMATIC_STREAK_BALANCE = "automaticStreakBalance",
  AUTOMATIC_STREAK_CONFIG = "automaticStreakConfig",
  AUTOMATIC_STREAK_MINIMUM_REQUIRED_BALANCE = "automaticStreakMinimumRequiredBalance",
  AUTOMATIC_STREAK_CGU_STATUS = "automaticStreakCguStatus",

  // Onchain Swap endpoints
  WALLET_AGE_ELIGIBILITY = "walletAgeEligibility",

  // Market Rate
  PUBLIC_MARKET_RATE = "publicMarketRate",

  // PnL Snapshots
  PNL_SNAPSHOTS = "pnlSnapshots",
  PNL_PRICE_EVENTS = "pnlPriceEvents",
  USER_PNL_STATS = "userPnlStats",

  // Arena chat
  ARENA_CHAT = "arenaChat",

  // Arena support chat
  ARENA_SUPPORT_CONVERSATION = "arena-support-conversation",
  ARENA_SUPPORT_MESSAGES = "arena-support-messages",

  // Arena market favorites
  ARENA_MARKET_FAVORITES = "arena-market-favorites",

  // Polymarket endpoints
  POLYMARKET_EVENTS_BY_IDS = "polymarketEventsByIds",
  POLYMARKET_ORDERBOOK = "polymarketOrderbook",

  // Internal Feature Flags
  INTERNAL_FEATURE_FLAGS = "internalFeatureFlags",

  // Portfolio
  PORTFOLIO_BALANCES = "portfolio-balances",

  // Airdrop Farming
  AIRDROP_FARMING_BOTS = "airdropFarmingBots",
  AIRDROP_FARMING_BOT_STATS = "airdropFarmingBotStats",
  AIRDROP_FARMING_BOT_PERFORMANCE = "airdropFarmingBotPerformance",
  AIRDROP_FARMING_SUGGEST_PAIRS = "airdropFarmingSuggestPairs",
  AIRDROP_FARMING_MAINTENANCE_WINDOW = "airdropFarmingMaintenanceWindow",
  PENDING_BOT_RATING = "pendingBotRating",

  // Delta-Neutral
  DELTA_NEUTRAL_BOTS = "deltaNeutralBots",
  DELTA_NEUTRAL_LEG_INFO = "deltaNeutralLegInfo",

  // Hub User
  HUB_USER_ACCOUNTS = "accounts",
}

export const getLeaderboardQueryKey = (campaign: string, epochId?: number) => [
  QueryKeys.LEADERBOARD,
  campaign,
  epochId,
];

export const getArenaFinalizationQueryKey = (campaign: string, epochId?: number) => [
  QueryKeys.CEDE_ARENA_FINALIZATION,
  campaign,
  epochId,
];

export const getArenaChatQueryKey = (campaign: string, epochId?: number) => [QueryKeys.ARENA_CHAT, campaign, epochId];

/** Per viewer, so a sign-out never serves the previous user's stars. */
export const getArenaMarketFavoritesQueryKey = (hubUserId?: number) => [QueryKeys.ARENA_MARKET_FAVORITES, hubUserId];

/**
 * Keyed on the viewer, like every other per-user key here. Without the id a
 * sign-out leaves the previous user's support thread in the cache under a key
 * the next sign-in reads straight back — nothing resets the cache on logout,
 * and these carry personal support content. The prefix still matches for
 * invalidation, so callers that invalidate by prefix are unaffected.
 */
export const getArenaSupportConversationQueryKey = (hubUserId?: number) => [
  QueryKeys.ARENA_SUPPORT_CONVERSATION,
  hubUserId,
];
/**
 * Viewer-scoped, NOT conversation-scoped: the widget renders one continuous
 * transcript across every conversation the caller owns, so a resolved thread
 * stays readable. The SSE append writes to this same key.
 */
export const getArenaSupportMessagesQueryKey = (hubUserId?: number) => [QueryKeys.ARENA_SUPPORT_MESSAGES, hubUserId];

export const getPnlSnapshotsQueryKey = (campaign: string, epochId: number, limit?: number) => {
  const key: (string | number)[] = [QueryKeys.PNL_SNAPSHOTS, campaign, epochId];
  if (limit !== undefined) key.push(limit);
  return key;
};

export const getUserPnlStatsQueryKey = (campaign: string, epochId?: number) => [
  QueryKeys.USER_PNL_STATS,
  campaign,
  epochId,
];

export const getPnlPriceEventsQueryKey = (campaign: string, epochId: number) => [
  QueryKeys.PNL_PRICE_EVENTS,
  campaign,
  epochId,
];

// Hold-to-Earn query key utilities
export const getHoldParticipantStatusQueryKey = (campaignId: string, hubUserId?: number) => [
  QueryKeys.HOLD_TO_EARN_PARTICIPANT_STATUS,
  campaignId,
  hubUserId,
];

export const getHoldLeaderboardQueryKey = (campaignId: string, epochId: number) => [
  QueryKeys.HOLD_TO_EARN_LEADERBOARD,
  campaignId,
  epochId,
];

export const getHoldEpochStatisticsQueryKey = (campaignId: string, epochId: number) => [
  QueryKeys.HOLD_TO_EARN_EPOCH_STATISTICS,
  campaignId,
  epochId,
];

export const getPolymarketEventsByIdsQueryKey = (eventIds: string[]) => [
  QueryKeys.POLYMARKET_EVENTS_BY_IDS,
  ...[...eventIds].sort(),
];

export const getPortfolioBalancesQueryKey = (accountId: number, walletTypes: string[]) =>
  [QueryKeys.PORTFOLIO_BALANCES, accountId, walletTypes.join(",")] as const;
